import React from "react";

export const ButtonOne = ({ text, style, onClick, disabled }) => {
  return (
    <button
      style={{ ...buttonOneStyle.buttonContainer, ...style }}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export const CircleButton = ({ text, img, size, onClick, styles }) => {
  return (
    <div
      style={{
        display: "flex",
        width: size,
        height: size,
        flex: "0 0 " + { size },
        alignItems: "center",
        justifyContent: "center",
        ...styles,
      }}
      onClick={onClick}
    >
      <button
        style={{
          backgroundColor: "transparent",
          borderColor: "transparent",
          padding: 0,
          cursor: onClick && "pointer",
        }}
      >
        <div
          style={{
            display: "flex",
            height: size * 1.7,
            width: size * 1.7,
            border: "3px solid #FFFFFF",
            borderRadius: "100%",
            backgroundColor: "#E0E5F2",
            fontSize: "10px",
            alignItems: "center",
            justifyContent: "center",
            color: "#4318FF",
            fontFamily: "DM Sans",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "24px",
          }}
        >
          {img !== undefined ? (
            <img
              style={{
                borderRadius: "100%",
                height: "100%",
                width: "100%",
              }}
              src={img}
              alt=""
            />
          ) : null}
          {text}
        </div>
      </button>
    </div>
  );
};

export const People = ({ circleSize, textOne, textTwo, textThree, imgOne, imgTwo, imgThree }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "4%",
        margin: "2%",
      }}
    >
      <CircleButton size={circleSize} img={imgOne} text={textOne}></CircleButton>
      <CircleButton size={circleSize} img={imgTwo} text={textTwo}></CircleButton>
      <CircleButton size={circleSize} img={imgThree} text={textThree}></CircleButton>
    </div>
  );
};

export const CommunityButton = ({ text, onClick, styles }) => {
  return (
    <button onClick={onClick} style={{ ...communityButtonStyle, ...styles }}>
      {text}
    </button>
  );
};

const buttonOneStyle = {
  buttonContainer: {
    display: "flex",
    marginRight: 0,
    backgroundColor: "#78D504",
    borderRadius: "70px",
    border: 0,
    color: "white",
    height: "34px",
    fontSize: "14px",
    fontWeight: "500",
    width: "70px",
    alignItems: "center",
    justifyContent: "center",
  },
};

const communityButtonStyle = {
  borderRadius: "50px",
  backgroundColor: "#2B3674",
  border: 0,
  fontSize: "16px",
  padding: "0 16px",
  boxShadow: "0px 3px 5px 0px rgb(0 0 0 / 50%)",
};
